import {
  ADS_CAMPAIGNS_DEMO,
  ADS_CAMPAIGNS_DEMO_DATE_RANGE,
  ADVERTISERS_DEMO,
} from "./constants";

export const isAdsCampaignDemo = (campaignID) =>
  Boolean(campaignID) && ADS_CAMPAIGNS_DEMO.includes(campaignID);

export const getAdsCampaignDemoDateRange = () => ({
  startDateTime: new Date(ADS_CAMPAIGNS_DEMO_DATE_RANGE.startDateTime),
  endDateTime: new Date(ADS_CAMPAIGNS_DEMO_DATE_RANGE.endDateTime),
});

export const shouldUseAdsCampaignDemoDateRange = ({
  campaignID,
  advertiserID,
} = {}) => {
  if (isAdsCampaignDemo(campaignID)) {
    return true;
  }

  if (advertiserID && ADVERTISERS_DEMO.includes(advertiserID)) {
    return true;
  }

  return false;
};
